import React, { useContext, createRef } from 'react';
import { DataGrid } from '../../../../../components/DataGrid/DataGrid';
import moment from 'moment-jalaali';
import { localText } from '../../../../../langs/fa/data-grid';
import formatNumber from '../../../../../fns/formatNumber';
import Avatar from '../../../../../components/User/UserAvatar';
import { store } from './reducer';
import Pdf from 'react-to-pdf';
import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';

const ref = createRef();

const List = () => {
  const {
    state: { report, page, progress },
    dispatch,
    itemsCountPerPage,
    showMessage,
    showError,
  } = useContext(store);
  const columns = [
    {
      field: 'rowNumber',
      headerName: 'ردیف',
      width: 100,
    },
    {
      field: 'createdAt',
      headerName: 'تاریخ ثبت نام',
      width: 150,
    },
    {
      field: 'name',
      headerName: 'نام و نام خانوادگی',
      renderCell: ({ value }) =>
        value ? <Avatar user={value} fullName /> : '',
      flex: 1,
    },
    {
      field: 'state',
      headerName: 'استان',
      width: 100,
    },
    {
      field: 'city',
      headerName: 'شهرستان',
      width: 150,
    },
    {
      field: 'fleet',
      headerName: 'نوع‌ناوگان',
      flex: 1,
    },
    {
      field: 'insuranceCompany',
      headerName: 'نام‌بیمه',
      width: 100,
    },
    {
      field: 'thirdPartyInsuranceExpireDate',
      headerName: 'تاریخ‌ سررسید',
      width: 150,
    },
  ];
  const printOptions = {
    orientation: 'landscape',
    unit: 'in',
    format: [11.7, 8.3],
  };

  const handlePageChange = ({ page }) => {
    dispatch({ type: 'PAGE', payload: page });
  };

  var _reports = report?.docs?.map
    ? report.docs.map((report, i) => ({
        id: report._id,
        rowNumber: itemsCountPerPage * (page - 1) + i + 1,
        createdAt: report?.createdAt
          ? moment(report.createdAt).format('jYYYY/jMM/jDD')
          : '',
        name: report?.user,
        city: report?.user?.city ? report.user.city.title : '',
        state: report?.user?.state ? report.user.state.title : '',
        fleet: report?.fleetOptions?.[0]
          ? `${report.fleetOptions[0]?.fleet?.title}(${report.fleetOptions[0]?.title})`
          : '',
        insuranceCompany: report?.insuranceCompany || '',
        thirdPartyInsuranceExpireDate: report?.thirdPartyInsuranceExpireDate
          ? moment(report.thirdPartyInsuranceExpireDate).fromNow()
          : '',
      }))
    : [];

  return (
    <>
      <div style={{ height: 750 }} ref={ref}>
        <DataGrid
          rows={_reports}
          columns={columns}
          localeText={localText}
          pageSize={itemsCountPerPage}
          rowCount={report?.totalDocs || 0}
          paginationMode="server"
          onPageChange={handlePageChange}
          loading={progress}
          disableMultipleSelection
          //   onCellClick={handleSelectOrder}
          density="compact"
        />
      </div>
      <Pdf
        targetRef={ref}
        filename="گزارش سررسید بیمه‌ها.pdf"
        scale={1}
        options={printOptions}
      >
        {({ toPdf }) => (
          <Button startIcon={<SaveIcon />} style={{ backgroundColor: 'green', color: 'white' }} onClick={toPdf} fullWidth={false}>
            دانلود PDF
          </Button>
        )}
      </Pdf>
    </>
  );
};

export default React.memo(List);
